import { Injectable } from '@angular/core';
import { Subscription, catchError, finalize, map, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpRequest, HttpEvent, HttpHeaders, HttpEventType, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ServerResponseState } from 'src/app/core/modals/response-type';
import { buildQueryParams, mediaFile } from 'src/app/core/modals/Pagination';

@Injectable({
  providedIn: 'root'
})
export class UploadService {

  constructor(private http: HttpClient) { }

  upload(file: File) {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);

    const post$ = this.http.post(`${environment.apiUrl}/ajax/upload/upload`, formData, {
      reportProgress: true,
      observe: 'events'
    })
    return post$;
  }

  getFiles(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/ajax/upload/get-file`);
  }

  mediaCreate(file: File) {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post(`${environment.mediaApiUrl}/index/upload`, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  docCreate(file: File) {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post(`${environment.mediaApiUrl}/index/upload`, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  imageCrop(data: any) {
    console.log(data);
    // let params = buildQueryParams(data);
    // const formData: FormData = new FormData();
    // formData.append('file', params);
    // return this.http.post(`${environment.mediaPath}/index/resize`, data, {
    //   reportProgress: true,
    //   observe: 'events'
    // });
    return this.http.post<ServerResponseState>(`${environment.mediaApiUrl}/index/upload-resize`, data).pipe(
      map((res: ServerResponseState) => {
        return res;
      }),
      catchError(this.handleError)
    );
  }

  multipleFile(file: File[]) {
    let params = mediaFile(file);
    return this.http.post<ServerResponseState>(`${environment.mediaApiUrl}/index/multiple`, params).pipe(
      map((res: any) => {
        if (res.statusCode == 201 || res.status == 'success') {
          return { status: true, data: res.result };
        } else if (res.statusCode == 201 || res.status == 'failed') {
          return { status: false, errors: res.error, message: res.message };
        } else {
          //console.log(res);
        }
      }),
      catchError(this.handleError)
    );
  }

  delete(data) {
    return this.http.post<ServerResponseState>(`${environment.mediaApiUrl}/attachment/delete`, data).pipe(
      map((res: ServerResponseState) => {

      }),
      catchError(this.handleError)
    );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.status === 400) {
      return error.error.message;
    }
    return throwError(error);
  }

  private getServerErrorMessage(error: HttpErrorResponse): string {
    switch (error.status) {
      case 404: {
        return `Not Found: ${error.message}`;
      }

      case 403: {
        return `Access Denied: ${error.message}`;
      }

      case 500: {
        return `Internal Server Error: ${error.message}`;
      }

      default: {
        return `Unknown Server Error: ${error.message}`;
      }
    }
  }

}
